import { loadQuery } from 'react-relay';

import { getAccountId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';
import {
  salesOrdersPaginationQuery,
  salesOrdersPaginationQuery$variables,
} from 'services/salesOrder/__generated__/salesOrdersPaginationQuery.graphql';
import { SALES_ORDERS_PAGINATION_QUERY } from 'services/salesOrder/salesOrder.relay.services';

export const getBaseSalesOrderVariables = (accountId: string): salesOrdersPaginationQuery$variables => ({
  first: 10,
  filter: {
    where: getBaseSalesOrdersFilter(accountId),
  },
  ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
  skip: accountId === '' ? true : false,
});

export const getBaseSalesOrdersFilter = (accountId: string) => ({
  // filters out sales orders that are from Unmind and Frankie Sessions
  contact: {
    source: {
      in: ['user', 'sign_up_form'],
    },
  },
  accountId: {
    equalTo: accountId,
  },
  deletedAt: {
    isNull: false,
  },
});

export const InvoicesPreloadData = () => {
  const accountId = getAccountId();

  return {
    salesOrdersQueryRef: loadQuery<salesOrdersPaginationQuery>(
      RelayEnvironment,
      SALES_ORDERS_PAGINATION_QUERY,
      {
        ...getBaseSalesOrderVariables(accountId),
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type InvoicesPreloadDataType = ReturnType<typeof InvoicesPreloadData>;
